import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#0b9949] text-white py-10">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8">
          {/* Brand/Copyright */}
          <div className="text-center md:text-left space-y-1">
            <p className="text-lg font-medium">
              © {new Date().getFullYear()}{" "}
              <span className="font-extrabold tracking-tight">Greenmark</span>. All Rights Reserved.
            </p>
            <p className="text-xs opacity-70 uppercase tracking-widest">
              Premier Industrial Training & Certification
            </p>
            <div className="pt-1 text-xs">
              <Link to="/privacy-policy" className="opacity-70 hover:opacity-100 hover:underline transition-opacity">
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Social Icons - Shifted left with pr-20 on desktop to avoid floating buttons overlap */}
          <div className="flex items-center gap-6 md:pr-24">
            <span className="text-xs font-bold opacity-60 uppercase tracking-widest hidden lg:block">Connect</span>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/profile.php?id=61587506786083"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all duration-300 border border-white/5 shadow-sm"
                title="Facebook"
              >
                <Facebook size={22} />
              </a>
              <a
                href="https://www.linkedin.com/company/greenmark-singapore/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 hover:scale-110 transition-all duration-300 border border-white/5 shadow-sm"
                title="LinkedIn"
              >
                <Linkedin size={22} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
